export { default } from "./ReservationsTemplate"
